import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./bens.component.html')
})
export class BensComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bens.component.ts
 **/